import { useDispatch, useSelector } from "react-redux";
import { addCachedAsset_Medium, selectCachedAsset, selectCachedAssets_medium } from "../app/slices/AssetsSlice";
import { selectToken } from "../app/slices/AuthenticationSlice";
import { selectCurrentOrganization } from "../app/slices/UserSlice";
import { AssetService } from "../services/AssetService";
import { selectCurrentLanguage } from "../app/slices/TrainingLocalizationSlice";
import { resolveVariant } from "../features/variants/resolveVariant";

export const useMediumAssetPreview = (assetId: string | undefined) => {
  const cachedAsset = selectCachedAsset(useSelector(selectCachedAssets_medium), assetId);
  // The project language picks the variant, so the preview shows what that language plays.
  const languageCode = useSelector(selectCurrentLanguage)?.shortcode;
  const previewUrl = resolveVariant(cachedAsset?.variants, languageCode)?.downloadUri;
  const assetName = cachedAsset?.name;

  var orgId = useSelector(selectCurrentOrganization)?.id;
  var token = useSelector(selectToken);
  const dispatch = useDispatch();

  const fetchAsset = async () => {
    if (!orgId || !assetId) return;

    var asset = await AssetService.GetAssetByGuid(orgId, token, assetId, false, "medium");

    if (asset) {
      dispatch(addCachedAsset_Medium(asset));
    }
  };

  const getAssetPreview = () => {
    if (!previewUrl) {
      fetchAsset();
    }

    return previewUrl;
  };

  const getAssetName = () => {
    if (!assetName) {
      fetchAsset();
    }
    return assetName;
  };

  return { getAssetPreview, getAssetName } as const;
};
